import { useState, useEffect } from "react";
import { MatchingLoadingState } from "./SemanticMatchResultsList";
import { Button } from "../../../../../components/buttons/button";

interface Props {
  onSubmit: (text: string) => void;
  onCancel: () => void;
  isPending?: boolean;
}

export const QuickAssignmentInput = ({ onSubmit, onCancel, isPending }: Props) => {
  const [value, setValue] = useState("");
  const [submitted, setSubmitted] = useState(false);

  // Reset submitted state if parsing failed (isPending went false without unmounting)
  useEffect(() => {
    if (!isPending) {
      setSubmitted(false);
    }
  }, [isPending]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (value.trim() && !isPending && !submitted) {
        setSubmitted(true);
        onSubmit(value);
        setValue("");
      }
    }
  };

  if (submitted || isPending) {
    return <MatchingLoadingState phase="parsing" />;
  }

  const handleSubmit = () => {
    if (value.trim() && !isPending && !submitted) {
      setSubmitted(true);
      onSubmit(value);
      setValue("");
    }
  };

  return (
    <div className="w-full bg-white rounded-2xl border border-gray-200 p-4 flex flex-col gap-3">
      <textarea
        className="w-full min-h-24 resize-none outline-none text-sm text-gray-700 placeholder:text-gray-400"
        placeholder="Add assignment description..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        autoFocus
      />
      <div className="flex justify-center gap-2">
        <Button variant="secondary" onClick={onCancel}>
          Remove Lead
        </Button>
        <Button variant="magic" onClick={handleSubmit} disabled={!value.trim()}>
          Go
        </Button>
      </div>
    </div>
  );
};
